var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"version2-header-two"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('img',{attrs:{"src":require("../../../../static/version2/右边板块标题样式.png"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }